var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"chat-filters-container"}},[_c('search'),_c('div',{staticClass:"d-flex"},[_c('sorting'),_c('property-filters')],1)],1),_c('status-filters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }